import { logger } from '@/services/LoggingService';

export interface WaitlistState {
  // Waitlist dialog state (auth-related UI state)
  waitlist: {
    showDialog: boolean;
    email: string | null;
  } | null;
}

export interface WaitlistActions {
  // Waitlist management
  setWaitlistDialog: (email: string) => void;
  clearWaitlistDialog: () => void;
}

export const createWaitlistActions = (set: any, get: any) => ({
  // Waitlist management
  setWaitlistDialog: (email: string) => {
    logger.info('AuthStore', 'Setting waitlist dialog', { email });
    set({ waitlist: { showDialog: true, email } });
  },

  clearWaitlistDialog: () => {
    logger.debug('AuthStore', 'Clearing waitlist dialog');
    set({ waitlist: null });
  }
});